<template>
  <div class="bg-light pt-3 pt-lg-5 pb-5">
    <b-container fluid>
      <b-row>

        <b-col cols="12" lg="3" xl="2" class="p-0">
          <DashUserNav></DashUserNav>
        </b-col>

        <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">

          <h5>Segurança</h5>
          <hr>

          <!-- ====== Alterar Senha ====== -->
          <b-row>
            <b-col cols="12" class="mt-4">

              <el-card class="box-card dashboard-card">

                <div slot="header">
                  <span>Alterar Senha</span>

                  <el-button
                    :disabled="editPass"
                    class="text-primary"
                    @click="editPass = true"
                    style="float: right; padding: 3px 10px"
                    :type="!editPass ? 'defauld' : 'primary'"
                    icon="el-icon-edit">
                    Editar Senha
                  </el-button>

                </div>

                <el-form :model="userPassword" :rules="userPasswordRules" ref="userPassword"
                         size="small" class="checkout-form dashboard-form pl-1 pr-1">

                  <el-row :gutter="20" class="">

                    <el-col :span="24" :md="8">
                      <el-form-item label="Senha Atual" prop="password">
                        <el-input
                          placeholder="Digite sua senha atual"
                          v-model="userPassword.password"
                          show-password
                          :readonly="!editPass"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" :md="8">
                      <el-form-item label="Nova Senha" prop="newPassword">
                        <el-input
                          placeholder="Digite sua nova senha"
                          v-model="userPassword.newPassword"
                          show-password
                          :readonly="!editPass"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" :md="8">
                      <el-form-item label="Confirmar Senha" prop="confirmPassword">
                        <el-input
                          placeholder="Confirme sua senha"
                          v-model="userPassword.confirmPassword"
                          show-password
                          :readonly="!editPass"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col v-show="editPass" :span="24" class="text-center">

                      <el-button
                        :disabled="!editPass"
                        @click="submitPass('userPassword')"
                        :round="true"
                        :loading="loading.savePass"
                        type="primary"
                        size="mini"
                        class="w-50 text-uppercase font-weight-bold"
                      >
                        Alterar Senha
                      </el-button>

                      <el-button
                        :disabled="!editPass"
                        @click="editPass = false"
                        :round="true"
                        :loading="false"
                        type="info"
                        plain
                        size="mini"
                        class="text-uppercase font-weight-bold"
                      >
                        Cancelar
                      </el-button>

                    </el-col>
                  </el-row>
                </el-form>

              </el-card>
            </b-col>
          </b-row>

          <Pin></Pin>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";
import header from "@/services/header";
import Pin from "./pin"

export default {
  name: 'Security',
  components: {
    DashUserNav,
    Pin
  },
  data() {
    return {
      loading: {
        savePass: false
      },
      editPass: false,
      userPassword: {
        password: '',
        confirmPassword: '',
        newPassword: '',
      },
      userPasswordRules: {
        password: [
          {required: true, message: 'Por favor, digite sua senha atual', trigger: 'blur'},
        ],
        newPassword: [
          {required: true, validator: this.checkPass, trigger: 'blur'}
        ],
        confirmPassword: [
          {required: true, validator: this.checkConfirmPassword, trigger: 'blur'}
        ],
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      apiV1: process.env.VUE_APP_API_V1,
    }
  },
  async mounted() {


  },
  methods: {

    submitPass(formName) {

      this.$refs[formName].validate((valid) => {

        this.loading.savePass = true;

        if (valid) {
          const {password, confirmPassword, newPassword} = this.userPassword;
          const data = {
            password,
            confirmPassword,
            newPassword
          };

          this.axios.post(`${this.baseUrl + this.apiV1}/user/change_password`, {data}, header)
            .then((response) => {
              this.$message({
                message: response.data.message,
                type: 'success'
              });
              this.loading.savePass = false;
              this.editPass = false;
              this.resetForm(formName)

            })
            .catch(() => {
              this.loading.savePass = false;
              this.editPass = false;
              this.resetForm(formName)
            });
        } else {
          this.loading.savePass = false;
          return false;
        }
      });
    },

    checkPass(rule, value, callback) {
      if (!value) {
        return callback(new Error('Digite sua nova senha'));
      }
      if (value.length < 6) {
        callback(new Error('Mínimo de 6 caracteres'));
      }
      if (value.length > 12) {
        callback(new Error('Máximo de 12 caracteres'));
      }

      callback();
    },

    checkConfirmPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('Por favor, confirme sua senha'));
      }
      if (value !== this.userPassword.newPassword) {
        callback(new Error('As senhas não conferem!'));
      }

      callback();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

  },
  watch: {

  }
}
</script>

<style scoped>

</style>
